
import { Inject, Options, Prop, Vue, Watch } from "vue-property-decorator";
import { AppInsights } from "@/trust-admin-app/appInsights";
import { TrustAPI } from "@/shared/modules/trust-api";
import LoadingIndicator from '@/shared/components/loading-indicator/index.vue';
import { EventEmitter } from "events";
import store from "@/trust-atcs-app/store";
import ErrorIndicator from "@/shared/components/error-indicator/index.vue";
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';
import { orderBy } from "lodash";
import { Category, SignatoryFilterRequest, SignatoryRequest, SignatoryView, PracticeView } from "@/shared/modules/typescript-trustapi-client/models";
import AddEditSignatoryModal from "./add-edit-signatory-modal/index.vue";
import { ref } from "vue";
import moment from "moment";
import { createCSV, escapeString } from "@/shared/components/helpers";
import { IDLESessionManager } from "@/trust-atcs-app/modules/session/idle-session-manager";
@Options({
  components: {
    LoadingIndicator,
    ErrorIndicator,
    AddEditSignatoryModal,
  },
  mixins: [FormatDateTimeMixin]
})
export default class PracticePeopleSignatories extends Vue {
  private ai = new AppInsights;

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  @Prop({ default: false })
  private selectedPractice!: any;

  @Prop({ default: false })
  private practices!: any;

  @Watch('selectedPractice', { immediate: true })
  private onPracticeChange() {
    this.currentPracticeView = this.selectedPractice;
  }

  @Watch('currentPracticeView', { immediate: true })
  private onPracticeViewChange(newVal: any, old: any) {
    this.$emit('onSelectedPracticeChange', this.currentPracticeView);
    if (this.currentPracticeView) {
      this.loadTableData(!!old?.practiceCoreId && old?.practiceCoreId !== newVal?.practiceCoreId, old?.practiceCoreId);
    }

  }

  private searchKeyword = '';
  private showActiveOnly = true;
  private showPCOnly = false;

  private sortMethod = 'desc';
  private activeSortHeader = 0;

  private signatories: SignatoryView[] = [];
  private signatoriesDisplay: any = [];
  private showAddEditModal = false;

  private signatoryRequest: SignatoryRequest = {};
  private categories: Category[] = [];

  private loadingContent = false;
  private errorLoadingContent = false;
  private loadingDataSet = false;
  private errorLoadingDataSet = false;

  private currentPracticeView: any = null;
  private searchText = null;

  private tableHeadings = [
    { text: 'LawID', value: 'lawId', sortable: true, sortMethod: 'desc' },
    { text: 'Name', value: 'name', sortable: true, sortMethod: 'acs' },
    { text: 'Position', value: 'categoryName', sortable: true, sortMethod: 'acs' },
    { text: 'Solely/ jointly', value: 'solelyJointly', sortable: true, sortMethod: 'acs' },
    { text: 'Commenced', value: 'commencedDate', sortable: true, sortMethod: 'asc' },
    { text: 'Terminated', value: 'terminatedDate', sortable: true, sortMethod: 'acs' },
    { text: 'Action', value: '', sortable: false, sortMethod: 'acs' },
  ];

  private idleSessionMgr: IDLESessionManager = new IDLESessionManager(60);

  created(): void {
    this.currentPracticeView = this.selectedPractice;
    this.getCategories();
  }

  mounted(): void {
    this.eventCtrl.on('loadSignatoriesData', this.loadTableData);
  }

  beforeUnmount(): void {
    this.eventCtrl.removeListener('loadSignatoriesData', this.loadTableData);
  }


  private async loadTableData(releasePreviousPracticeLock = false, previousPracticeID: number = null as any): Promise<void> {
    this.loadingContent = true;
    try {

      this.loadingContent = true;
      this.errorLoadingContent = false;

      if (releasePreviousPracticeLock) {
        await this.apiService.PeopleAtcsApi?.apiV2AtcsPeopleReleaseManageSignatoryLockPost({
          practiceCoreId: previousPracticeID,
          updatingKey: this.signatoriesUpdatingKey
        });
        store.dispatch('setSignatoriesUpdatingKey', null);
      }

      store.dispatch('setSelectedPracticeCoreId', this.currentPracticeView.practiceCoreId);

      const resp0: any = await this.apiService.PeopleAtcsApi?.apiV2AtcsPeopleGetManageAuthorisedSignatoryPageStatusPracticeCoreIdGet(this.currentPracticeView.practiceCoreId);

      if (resp0.data?.data?.isUpdating) {
        this.$emit('concurrencyError', resp0.data.data);
      } else {
        const resp: any = await this.apiService.PeopleAtcsApi?.apiV2AtcsPeopleGetSignatoriesPost(
          {
            practiceCoreId: this.currentPracticeView.practiceCoreId,
            updatingKey: this.signatoriesUpdatingKey
          }
        );

        store.dispatch('setSignatoriesUpdatingKey', resp.data.data?.updatingKey);
        console.log(resp.data.data?.updatingKey, this.signatoriesUpdatingKey);
        this.signatories = resp.data.data?.practiceSignatories ?? [];
        this.signatoriesDisplay = this.signatories;
        for (let i = 0; i < this.signatories.length; i++) {
          this.signatoriesDisplay[i].name = this.signatories[i].firstName + ' ' + this.signatories[i].lastName;
          this.signatoriesDisplay[i].categoryName = this.signatories[i].category.name;
        }

        this.sortTableColumn(1, true);

      }

    } catch (error: any) {
      if (error?.response?.data?.errorCode) {
        this.$emit('concurrencyError', error?.response?.data);
      } else {
        this.eventCtrl.emit('show-snackbar', 'error', 'Unable to get signatory list: ' + error);
        this.ai.trackException('Error, Unable to get signatory list: ' + error);
      }

      this.loadingContent = false;
      this.errorLoadingContent = true;
    } finally {
      this.loadingContent = false;
    }

  }

  private sortTableColumn(index: number, sortable: boolean): void {
    if (sortable) {
      if (this.tableHeadings[index].sortable) {
        this.activeSortHeader = index;
        this.sortMethod = this.sortMethod === 'desc' ? 'asc' : 'desc';
        this.tableHeadings[index].sortMethod = this.sortMethod;
        if (this.signatories.length > 0) {
          const nameSorter = index == 1 ? (c: any) => c.name.toLowerCase() : [this.tableHeadings[index].value, (c: any) => c.name.toLowerCase()];
          const orderByResults = orderBy(
            this.signatories,
            nameSorter,
            [this.sortMethod as any]
          );
          this.signatoriesDisplay = orderByResults;
        }
      }
    }
  }

  private applyFilter(data: any): any[] {

    let tempResult = data;
    if (this.showActiveOnly) {
      tempResult = tempResult.filter((d: any) => this.isActive(d));
    }
    if (this.searchKeyword == '') return tempResult;
    tempResult = data.filter((d: any) => {
      return (d.name.toLowerCase().indexOf(this.searchKeyword.toLowerCase()) >= 0
        || d.lawId.toLowerCase().indexOf(this.searchKeyword.toLowerCase()) >= 0);
    })
    return tempResult;
  }

  private isActive(i: SignatoryView): boolean {
    const _terminatedDate = i.terminatedDate ?? null;
    if (_terminatedDate) {
      return moment().diff(i.terminatedDate, 'days') <= 0;
    } else {
      return true;
    }
  }

  private addNew(): void {
    this.signatoryRequest = {
      id: 0,
      practiceId: this.selectedPractice.id,
      signatoryTypeId: 1,
      solelyJointlyId: 0,
      lawId: '',
      firstName: '',
      lastName: '',
      categoryId: 0,
      commencedDate: ref(new Date()),
      terminatedDate: null,

    }
    this.showAddEditModal = true;
  }

  private edit(s: SignatoryView): void {
    // Clone this object
    this.signatoryRequest = { ...s };
    this.signatoryRequest.signatoryTypeId = s.signatoryType.id;
    this.signatoryRequest.solelyJointlyId = s.solelyJointly.id;
    // Get status id
    // this.signatoryRequest.statusId = s.status['id'];
    // set the date format for date picker
    this.signatoryRequest.commencedDate = new Date(this.signatoryRequest.commencedDate);
    this.signatoryRequest.terminatedDate = this.signatoryRequest.terminatedDate !== null ? new Date(this.signatoryRequest.terminatedDate) : null;

    this.signatoryRequest.categoryId = s.category['id'];
    this.showAddEditModal = true;
  }

  private onPracticeSelectChange(event: any): void {
    // this.currentPracticeView = event.target.value;
    this.$emit('onSelectedPracticeChange', event.target.value);

  }

  private async getCategories(): Promise<void> {
    try {
      const resp: any = await this.apiService.CodeApi?.apiV2CodeGetCategoriesGet();
      this.categories = resp.data.data;
    } catch (error) {
      console.log(error);
    }
  }

  private exportSignatoryCSV(i: SignatoryView): void {
    const headers: any[] = [
      'LawID',
      'Name',
      'Position',
      'Sorely/ jointly',
      'Commenced',
      'Terminated'
    ];

    let bodyString = '';
    let headersString = '';
    let dataString = '';

    headersString = headers.map((x: any) => escapeString(x)).join(',');
    headersString += '\r\n';


    bodyString += headersString;

    this.applyFilter(this.signatoriesDisplay).forEach((s: SignatoryView) => {

      dataString += [
        escapeString(s.lawId),
        escapeString(s.firstName + ' ' + s.lastName),
        escapeString(s.category.name),
        escapeString(s.solelyJointly.name),
        escapeString(this.$formatDate(s.commencedDate)),
        escapeString(this.$formatDate(s.terminatedDate))
      ].join(',');

      dataString += '\r\n';

    });

    bodyString += dataString;


    createCSV('Authorised Signatories', bodyString);


  }

  private loadingStateChanged(loadingStatus: boolean) {
    this.$emit('statusChange', loadingStatus);
  }


  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  get signatoriesPracticeCoreId(): number | null {
    return store.getters.getSelectedPracticeCoreId;
  }

  get signatoriesUpdatingKey(): string {
    return store.getters.getSignatoriesUpdatingKey;
  }

}

